const header = [
  { key: "home", path: "/" },
  { key: "menu", path: "/menu" },
  { key: "gallery", path: "/gallery" },
  { key: "about", path: "/about" },
  { key: "video", path: "/video" },
  { key: "contact", path: "/contact" },
];

export { header };
